import React from 'react'
import { CostItem } from '../CostItem'

export type Props = {
  value: number
  autoAdjusted?: boolean
}

export const SellingPrice = ({ value, autoAdjusted }: Props) => {
  return (
    <CostItem name={autoAdjusted ? 'Auto-adjusted selling price' : 'Selling price'} value={value} />
  )
}
